import { useBreakpointValue } from '@chakra-ui/react';

export function usePagePad() {
    return useBreakpointValue({ base: '1rem', md: '2rem' });
}
